import { useEffect } from 'react'
import { eventTrackService } from '../services/eventTrackService'

export const usePageView = () => {
  useEffect(() => {
    eventTrackService.page()
  }, [])
}
